
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bollettino-neve",
      function () {
        return require("private-next-pages/bollettino-neve.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bollettino-neve"])
      });
    }
  